































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import axios from 'axios';
import { uuid } from 'vue-uuid';
import {IInterface, IMultipleOutputs} from '../shared/services/models/Interface';
import {IPlaylist} from '../shared/services/models/Playlist';
import {ISetting} from '../shared/services/models/Setting';

@Component({
    components: {
        // @ts-ignore
        PlaylistEditComponent: require('../shared/components/PlaylistEdit').default,
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['playlists', 'interfaces', 'settings']),
    },
    methods: {
        ...mapActions(['updatePlaylists', 'addPlaylist', 'updatePlaylist', 'deletePlaylist', 'updateInterfaces']),
    },
})
export default class PlaylistComponent extends Vue {
    private playlists!: IPlaylist[];
    private interfaces!: IInterface[];
    private settings!: ISetting[];
    private playListName: string = '';
    private selectedPlaylist: IPlaylist | undefined = undefined;
    private mounted() {
        // @ts-ignore
        this.updatePlaylists();
        // @ts-ignore
        this.updateInterfaces();
    }

    private get SelectedPlaylist(): IPlaylist | undefined {
        if (this.selectedPlaylist !== undefined) {
            return this.selectedPlaylist;
        }

        return undefined;
    }

    private copyURLToClipboard(): void {
        this.$bvToast.toast('Copied to clipborad', {
            title: 'SRT URL',
            variant: 'info',
            solid: true,
        });
    }

    private editPlaylist(playlist: IPlaylist) {
        this.selectedPlaylist = playlist;
        this.$bvModal.show(`playlist-edit-modal-${playlist.id}`);
    }

    private addPlayList(): void {
        this.$bvModal.show('modal-add-playlist');
    }
    private addPlayListSave(): void {
        const pl: IPlaylist = {
            id: '',
            name: this.playListName,
            playlist: {
                vlc: [],
                playerPro: {
                    id: uuid.v4(),
                    name: this.playListName,
                    description: '',
                    icon: '',
                    version: 1,
                    lineups: [],
                },
            },
        };
        // @ts-ignore
        this.addPlaylist(pl);
        setTimeout(() => {
            // @ts-ignore
            this.updatePlaylists();
            this.playListName = '';
        }, 500);
    }

    private async savePlaylist(playlist: IPlaylist) {
        const plName: string = playlist.name;
        // @ts-ignore
        const result: boolean = await this.updatePlaylist(playlist);
        this.$bvToast.toast('Playlist saved', {
            title: plName,
            variant: result ? 'success' : 'warning',
            solid: true,
        });
    }

    private addURL(input: string[], playlist: IPlaylist) {
        if (playlist && playlist.playlist) {
            if (!Array.isArray(playlist.playlist.vlc)) {
                playlist.playlist.vlc = [];
                playlist.playlist.playerPro = {
                    id: playlist.id,
                    name: playlist.name,
                    description: '',
                    icon: '',
                    version: 1,
                    lineups: [],
                };
            }

            let vlcURL = input[0];
            let streamName = input[1];
            if (vlcURL.indexOf('StreamID') !== -1) {
                vlcURL = '#' + vlcURL;
                streamName += ' - ' + vlcURL.substring(vlcURL.indexOf('StreamID=') + 'StreamID='.length);
            }

            playlist.playlist.playerPro.id = playlist.id;
            playlist.playlist.playerPro.name = playlist.name;
            playlist.playlist.vlc.push(vlcURL);
            playlist.playlist.playerPro.lineups.push({
                id: uuid.v4(),
                name: streamName,
                type: 'play',
                description: '',
                url: input[0],
            });
        }
    }

     private removeURL(input: string, playlist: IPlaylist) {
        if (playlist && playlist.playlist) {
            if (Array.isArray(playlist.playlist.vlc)) {
                let index: number = playlist.playlist.vlc.indexOf(input);
                if (input.indexOf('StreamID') !== -1) {
                    index = playlist.playlist.vlc.indexOf(`#${input}`);
                }
                if (index !== -1) {
                    playlist.playlist.vlc.splice(index, 1);
                }
                // will assume order is preserved
                playlist.playlist.playerPro.lineups.splice(index, 1);
            }
        }
     }

   private downloadItem(playlist: IPlaylist) {
        axios.get(`/api/channel_list?action=vlc_playlist&id=${playlist.id}`, { responseType: 'blob' })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const link = document.createElement('a');

                    link.href = URL.createObjectURL(blob);
                    link.download = `${playlist.name}.m3u`;
                    link.click();
                    URL.revokeObjectURL(link.href);
        }).catch((error) => {
            window.console.error('downloadItem', error);
        });
    }

    private get URL(): string {
        const getUrl = window.location;
        return getUrl .protocol + '//' + getUrl.host + '/';
    }
}
